import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';

export const StyledFooterButton = styled.button`
	display: block;
	text-decoration: none;
	color: ${getColor('gray')};
	letter-spacing: 0px;
	line-height: 21px;
	margin-top: 5px;
	background-color: ${getColor('white')};
	border: none;
	font-size: 16px;
	font-weight: 400;
	padding: 0px;

	&:hover, &:focus, &:active {
		color: ${getColor('darkTeal')};
		text-decoration: none;
	}

	svg {
		margin-right: 11px;
	}
`;